import React from 'react';
import styles from "./Hero.module.css";
import Monogram from "assets/images/monogram.png";
import { useTranslation } from 'react-i18next';

const Hero = () => {
    const { t } = useTranslation();

    return (
    <section className={styles['hero-section']}>
        <div className={styles['hero-container']}>
        <div className={styles['hero-content']}>
            <div className={styles['hero-image']}>
                <img src={Monogram} alt="monogram" className={styles['monogram-image']} />
            </div>
                  <h1 className={styles['heading-hero']}>
            <span className={styles['text-shadow']}>
                {t('hero.colorTitle')}
            </span>
            <span className={styles['text-top']}>
                {t('hero.shadowTitle')}
            </span>
        </h1>
        </div>
        </div>
    </section>
    );
};

export default Hero;